import React from "react";
import "./styles.css";
import images from "../../assets";
import MembershipPlanColumn from "./membershipplancolumn";
import { Select, Divider, Checkbox } from "antd";
import PrimaryButton from "../button/primarybutton";
import CurrentPlanBox from "./planbox";

export default function CurrentPlanComp() {
  return (
    <div className="w-full bg-white rounded-2xl border border-primary50 justify-start gap-4 flex p-8 mb-4">
      <div className="w-full flex-col justify-start items-start gap-[38px] inline-flex">
        <div className="w-[350px] flex-col justify-start items-start gap-4 flex">
          <div className="self-stretch text-basePrimary text-xl font-semibold font-['Poppins'] leading-7">
            Current Membership: Standard
          </div>
          <div className="membership-plan-area">
            <div className="membership-plan-heading">
              <h1>Membership Plan Details</h1>
            </div>
            <div className="membership-plan-content">
              <div className="membership-plan-left">
                <MembershipPlanColumn
                  planname="Plan Name"
                  planvalue="Standard"
                />
                <MembershipPlanColumn planname="Price" planvalue="$00.00" />
                <MembershipPlanColumn
                  planname="Duration"
                  planvalue="Lifetime"
                />
                <MembershipPlanColumn planname="Contact Limit" planvalue="0" />
                <MembershipPlanColumn
                  planname="Message Limit"
                  planvalue="Limited"
                />
              </div>
              <div className="membership-plan-logo">
                <img src={images.membershipPlanIcon} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full self-stretch flex-col justify-start items-start gap-[27px] flex">
          <div className="flex-col justify-start items-start gap-[29px] flex">
            <h3 className="self-stretch text-basePrimary text-xl font-semibold font-['Poppins'] leading-7">
              Upgrade Membership
            </h3>
            <div className="self-stretch justify-start items-center gap-4 inline-flex">
              <p className="text-basePrimary text-base font-semibold font-['Poppins'] leading-normal">
                Upgrade By:
              </p>
              <div className="w-[518px]">
                <Select
                  showSearch
                  style={{
                    width: "100%",
                    height: 48,
                  }}
                  placeholder="Please Select"
                  options={[
                    {
                      value: "1",
                      label: "Admin",
                    },
                    {
                      value: "2",
                      label: "Super Admin",
                    },
                    {
                      value: "3",
                      label: "Other",
                    },
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="self-stretch flex-col justify-start items-start gap-[25px] flex">
            <div className="justify-start items-center gap-4 inline-flex">
              <p className="text-basePrimary text-xl font-semibold font-['Poppins'] leading-7">
                Plans:
              </p>
              <PrimaryButton
                style={{
                  width: "155px",
                  height: "32px",
                  fontSize: "14px",
                }}
                text={"Add New Plan"}
                iconalign="left"
                icon={images.plusIconWhite}
              />
            </div>
            <div className="self-stretch flex-col justify-start items-start flex">
              <div className="self-stretch justify-start items-center gap-4 inline-flex">
                <Divider>Admin</Divider>
              </div>
              <div className="justify-start items-center gap-[19px] flex flex-wrap">
                <CurrentPlanBox
                  duration="7 Days"
                  contact="0 Contact"
                  amount="$0.00"
                />
                <CurrentPlanBox
                  duration="15 Days"
                  contact="0 Contact"
                  amount="$0.00"
                />
                <CurrentPlanBox
                  duration="1 Months"
                  contact="0 Contact"
                  amount="$0.00"
                />
                <CurrentPlanBox
                  duration="3 Months"
                  contact="0 Contact"
                  amount="$0.00"
                />
                <CurrentPlanBox
                  duration="6 Months"
                  contact="0 Contact"
                  amount="$0.00"
                />
                <CurrentPlanBox
                  duration="Lifetime"
                  contact="0 Contact"
                  amount="$0.00"
                />
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-start flex">
              <div className="self-stretch justify-start items-center gap-4 inline-flex">
                <Divider>Stripe</Divider>
              </div>
              <div className="justify-start items-center gap-[19px] flex flex-wrap">
                <CurrentPlanBox
                  duration="1 Months"
                  contact="0 Contact"
                  amount="$17.99"
                />
                <CurrentPlanBox
                  duration="3 Months"
                  contact="0 Contact"
                  amount="$41.00"
                />
                <CurrentPlanBox
                  duration="Lifetime"
                  contact="0 Contact"
                  amount="$107.00"
                />
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-2.5 flex">
              <div className="self-stretch justify-start items-center gap-4 inline-flex">
                <Divider>Paypal</Divider>
              </div>
              <div className="justify-start items-center gap-[19px] flex flex-wrap">
                <CurrentPlanBox
                  duration="1 Months"
                  contact="15 Contact"
                  amount="$17.00"
                />
                <CurrentPlanBox
                  duration="3 Months"
                  contact="45 Contact"
                  amount="$41.00"
                />
                <CurrentPlanBox
                  duration="Lifetime"
                  contact="-- Contact"
                  amount="$107.00"
                />
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-2.5 flex">
              <div className="self-stretch justify-start items-center gap-4 inline-flex">
                <Divider>bKash</Divider>
              </div>
              <div className="justify-start items-center gap-[19px] flex flex-wrap">
                <CurrentPlanBox
                  duration="1 Months"
                  contact="15 Contact"
                  amount="$17.00"
                />
                <CurrentPlanBox
                  duration="3 Months"
                  contact="45 Contact"
                  amount="$41.00"
                />
                <CurrentPlanBox
                  duration="Lifetime"
                  contact="-- Contact"
                  amount="$107.00"
                />
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-2.5 flex">
              <div className="self-stretch justify-start items-center gap-4 inline-flex">
                <Divider>SSL Commerze</Divider>
              </div>
              <div className="justify-start items-center gap-[19px] flex flex-wrap">
                <CurrentPlanBox
                  duration="1 Months"
                  contact="15 Contact"
                  amount="$17.00"
                />
                <CurrentPlanBox
                  duration="3 Months"
                  contact="45 Contact"
                  amount="$41.00"
                />
                <CurrentPlanBox
                  duration="Lifetime"
                  contact="-- Contact"
                  amount="$107.00"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
